if (!customElements.get('header-drawer')) {
  class HeaderDrawer extends HTMLElement {
    constructor() {
      super();

      this.toggleDrawerRef = this.toggleDrawer.bind(this);
    }

    toggleDrawer() {
      this.classList.toggle('is-open');
      toggleLock(this.classList.contains('is-open'), this);
    }

    disconnectedCallback() {
      document.removeEventListener(
        'exo:toggle-header-drawer',
        this.toggleDrawerRef,
      );
    }

    connectedCallback() {
      document.addEventListener(
        'exo:toggle-header-drawer',
        this.toggleDrawerRef,
      );
    }
  }

  customElements.define('header-drawer', HeaderDrawer);
}
